import { useState, useCallback } from "react";
import { facturationTicket } from "../lib/ticket.js";

/**
 * Fournit une fonction `closeTicket({ idTicket, modeFacturation, idFacturant, custom })` pour clôturer un ticket et expose `{ closeTicket, loading, error }`.
 *
 * @returns {{ closeTicket: Function, loading: boolean, error: string|null }}
 */
export function useCloseTicket() {
  const [loading, setLoading] = useState(false);
  const [error, setError] = useState(null);

  const closeTicket = useCallback(async ({ idTicket, modeFacturation, idFacturant, custom = {} }) => {
    setLoading(true);
    setError(null);

    try {
      const result = await facturationTicket(idTicket, modeFacturation, idFacturant, custom);
      return result;
    } catch (err) {
      setError(err.message || "Erreur lors de la clôture du ticket");
      return false;
    } finally {
      setLoading(false);
    }
  }, []);

  return {
    closeTicket, // Fonction à utiliser
    loading,
    error,
  };
}
